import Analytics from '../utils/analytics';

export default class FreeTrialGTM {
    static trackPreapprovalModalView() {
        const eventData = {
            area: 'conversation_activation_required_modal_on_preapprobation',
            action: 'view',
            text: 'activation_required_to_preapprove'
        };
        Analytics.trackGTM('modal', { event_data: eventData });
    }

    static trackPreapprovalActivateMembership() {
        const eventData = {
            area: 'conversation_activation_required_modal_on_preapprobation',
            action: 'click',
            text: 'activate_hec_membership'
        };
        Analytics.trackGTM('button', { event_data: eventData });
    }

    static trackFinalizationModalView() {
        const eventData = {
            area: 'conversation_activation_required_modal_on_finalization',
            action: 'view',
            text: 'activation_required_to_finalize'
        };
        Analytics.trackGTM('modal', { event_data: eventData });
    }

    static trackFinalizationActivateMembership() {
        const eventData = {
            area: 'conversation_activation_required_modal_on_finalization',
            action: 'click',
            text: 'activate_hec_membership'
        };
        Analytics.trackGTM('button', { event_data: eventData });
    }
}
